<template>
  <div :class="isFocus?'flex-wrap flex-wrap-focus':'flex-wrap'">
    <div>
      <el-input
        ref="rangeStartInputRef"
        v-model="localStart"
        class="range-input range-input-start"
        placeholder="请输入"
        @input="handleStartInput"
        @blur="handleStartBlur"
      />
      <!-- <div v-if="startError" class="error-message">{{ startError }}</div> -->
    </div>
    <span class="placeholder">-</span>
    <div>
      <el-input
        ref="rangeEndInputRef"
        v-model="localEnd"
        class="range-input range-input-end"
        placeholder="请输入"
        @input="handleEndInput"
        @blur="handleEndBlur"
      />
      <!-- <div v-if="endError" class="error-message">{{ endError }}</div> -->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    start: {
      type: [String, Number],
      default: '',
    },
    end: {
      type: [String, Number],
      default: '',
    },
  },
  data() {
    return {
      localStart: this.start,
      localEnd: this.end,
      startError: '',
      endError: '',
      isFocus: false,
    };
  },
  watch: {
    start(newVal) {
      this.localStart = this.filterNumber(newVal);
      this.handleValidation();
    },
    end(newVal) {
      this.localEnd = this.filterNumber(newVal);
      this.handleValidation();
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.rangeStartInputRef.$refs.input.addEventListener('focus', this.focusListenners);
      this.$refs.rangeEndInputRef.$refs.input.addEventListener('focus', this.focusListenners);

      this.$refs.rangeStartInputRef.$refs.input.addEventListener('blur', this.blurListenners);
      this.$refs.rangeEndInputRef.$refs.input.addEventListener('blur', this.blurListenners);
    });
  },
  unmounted() {
    this.$refs.rangeStartInputRef.$refs.input.removeEventListener('focus', this.focusListenners);
    this.$refs.rangeEndInputRef.$refs.input.removeEventListener('focus', this.focusListenners);

    this.$refs.rangeStartInputRef.$refs.input.removeEventListener('blur', this.blurListenners);
    this.$refs.rangeEndInputRef.$refs.input.removeEventListener('blur', this.blurListenners);
  },
  methods: {
    focusListenners() {
      this.isFocus = true;
    },
    blurListenners() {
      this.isFocus = false;
    },
    // 过滤非数字字符，只保留数字
    filterNumber(value) {
      if (value === null || value === undefined) return '';
      // 只保留数字字符
      const filtered = String(value).replace(/[^\d]/g, '');
      return filtered;
    },

    // 验证字段是否为有效数字
    isNumberValid(value) {
      return value !== '' && !isNaN(Number(value)) && isFinite(value);
    },

    // 处理起始值输入
    handleStartInput() {
      this.localStart = this.filterNumber(this.localStart);
      this.handleValidation();
      this.notifyParent();
    },

    // 处理结束值输入
    handleEndInput() {
      this.localEnd = this.filterNumber(this.localEnd);
      this.handleValidation();
      this.notifyParent();
    },

    // 处理起始值失焦
    handleStartBlur() {
      this.handleValidation();
      this.notifyParent();
    },

    // 处理结束值失焦
    handleEndBlur() {
      this.handleValidation();
      this.notifyParent();
    },

    // 通知父组件更新
    notifyParent() {
      this.$emit('update:start', this.localStart);
      this.$emit('update:end', this.localEnd);
      this.$emit('change', {
        start: this.localStart,
        end: this.localEnd,
        valid: !this.startError && !this.endError,
      });
    },

    // 执行验证逻辑
    handleValidation() {
      const startValid = this.isNumberValid(this.localStart);
      const endValid = this.isNumberValid(this.localEnd);

      // 清除之前的错误
      this.startError = '';
      this.endError = '';

      // 双向验证规则
      if (startValid && endValid) {
        const startNum = Number(this.localStart);
        const endNum = Number(this.localEnd);

        if (startNum > endNum) {
          this.startError = '起始值不能大于结束值';
          this.endError = '结束值不能小于起始值';
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>

.flex-wrap {
  box-sizing: border-box;
  display: flex;
  align-items: flex-start;
  border: 1px solid #DCDFE6;
  height: 32px;
  line-height: 32px;
  border-radius: 4px;
  transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  overflow: hidden;
  &:hover {
    border-color: #C0C4CC;
  }
  &.flex-wrap-focus {
    border-color: #1C1C1C;
  }
  .range-input {
    /deep/ .el-input__inner {
      border: none;
    }
  }
}

.placeholder {
  line-height: 32px;
}
.error-message {
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  padding-top: 4px;
  min-height: 16px;
}
</style>
